import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useSchools from '@teetsh/app/src/queries/schools/useSchools';
import { MenuItemsLoader } from '@teetsh/app/src/containers/App/Breadcrumb/MenuItemsLoader';
import {
  Menu,
  SECTION_TITLE_STYLE,
  SELECTED_ITEM_STYLE,
} from '@teetsh/app/src/components/Menu';
import { CheckIcon as Check } from '@heroicons/react/20/solid';
import { School } from '@teetsh/app/src/types/school';
import _orderBy from 'lodash-es/orderBy';
import { fixRedirect } from 'containers/App/Breadcrumb/fixRedirect';
import 'twin.macro';
import { UsersIcon } from '@heroicons/react/24/outline';
import { useSharedSchools } from 'queries/schools/useSharedSchools';

function setSchoolInUrl(url: string, schoolId: string) {
  const urlSplited = url.split('/');
  urlSplited[4] = schoolId;
  return fixRedirect(urlSplited.join('/'));
}

interface Props {
  schoolyearId: string;
  school: School;
  label?: string;
  onClick?: (v: School) => void;
  children?: React.ReactNode;
}

export function SchoolsMenuItems(props: Props) {
  const { schoolyearId, school, label, onClick, children } = props;
  const { data, isLoading } = useSchools({
    schoolyearId,
  });
  const { data: sharedSchools = [] } = useSharedSchools();
  const location = useLocation();
  const navigate = useNavigate();

  if (isLoading) {
    return <MenuItemsLoader />;
  }
  return (
    <>
      <div>
        {label && <p css={SECTION_TITLE_STYLE}>{label}</p>}
        {_orderBy(data || [], 'name', ['asc']).map(sc => (
          <Menu.Item
            key={sc.id}
            icon={sc.id === school.id ? Check : 'div'}
            css={sc.id === school.id && SELECTED_ITEM_STYLE}
            onClick={() => {
              if (onClick) {
                onClick(sc);
              }
              navigate(setSchoolInUrl(location.pathname, sc.id));
            }}
            text={
              <div tw="flex items-center">
                {sc.name}
                {sharedSchools.some(s => s.id === sc.id) && (
                  <UsersIcon tw="ml-2 size-5" />
                )}
              </div>
            }
          />
        ))}
      </div>
      {children}
    </>
  );
}
